<!--
  Component for tracking authentication status of the user.
  Will emit event if auth status changes
-->
<template>
  <!-- Need to place something to DOM to be rendered correctly -->
  <div/>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['authenticatedUser'])
  },
  watch: {
    authenticatedUser: {
      handler() {
        this.$events.emit('auth')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/elements/AuthStatusTracker.vue